// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2y9v0","content":"styles_content__3qlUV","selectAll":"styles_selectAll__ZuTn9"};